var map = {
	"./NorthAfrican.png": 561,
	"./NorthAfricanWithoutLegend.png": 562,
	"./belgian.png": 563,
	"./euOther.png": 564,
	"./euro15.png": 565,
	"./euroNew13.png": 566,
	"./mix.png": 130,
	"./other.png": 567,
	"./southAmerican.png": 568,
	"./subSaharanAfrica.png": 569,
	"./turkish.png": 570
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 560;